import styled from 'styled-components';

const BazaarVoiceContainer = styled.div`
  overflow: hidden;
  color: white !important;

  #BVRRContainer
    .bv-content-feedback-voted-inappropriate
    .bv-content-report-btn {
    background-color: ${({ theme }) => theme.colors.link} !important;
  }
`;

export default BazaarVoiceContainer;
